import { createAction } from 'typesafe-actions'

export const resetCampaignDataAction = createAction('@company/RESET_CAMPAIGN_DATA')<void>()
